__turbopack_context__.v({
  "apocalypse": "MKWhEG_apocalypse",
  "barrenGlory": "MKWhEG_barrenGlory",
  "bookBurning": "MKWhEG_bookBurning",
  "button": "MKWhEG_button",
  "counterspell": "MKWhEG_counterspell",
  "curiosity": "MKWhEG_curiosity",
  "deafeningSilence": "MKWhEG_deafeningSilence",
  "etherswornCanonist": "MKWhEG_etherswornCanonist",
  "forbiddenOrchard": "MKWhEG_forbiddenOrchard",
  "gatekeeperOfMalakir": "MKWhEG_gatekeeperOfMalakir",
  "ghostlyPrison": "MKWhEG_ghostlyPrison",
  "lostInTheWoods": "MKWhEG_lostInTheWoods",
  "mentalMisstep": "MKWhEG_mentalMisstep",
  "message": "MKWhEG_message",
  "obliterate": "MKWhEG_obliterate",
  "oneWithNothing": "MKWhEG_oneWithNothing",
  "outOfTime": "MKWhEG_outOfTime",
  "possibilityStorm": "MKWhEG_possibilityStorm",
  "powerSink": "MKWhEG_powerSink",
  "ruleOfLaw": "MKWhEG_ruleOfLaw",
  "silence": "MKWhEG_silence",
  "sleep": "MKWhEG_sleep",
  "stallForTime": "MKWhEG_stallForTime",
  "temporaryLockdown": "MKWhEG_temporaryLockdown",
  "timeStop": "MKWhEG_timeStop",
  "totallyLost": "MKWhEG_totallyLost",
  "unexpectedlyAbsent": "MKWhEG_unexpectedlyAbsent",
  "winterOrb": "MKWhEG_winterOrb",
  "wrongTurn": "MKWhEG_wrongTurn",
  "zhalfirinVoid": "MKWhEG_zhalfirinVoid",
});
